// extracted by mini-css-extract-plugin
export default {"tabelaFontAjuste":"Tabela_tabelaFontAjuste__RNEie"};